export interface QuestionType {
  value: string;
  viewValue: string;
}

export interface SurveyQuestion {
  qtext: string;
  qtype: string;
  units: string;
  sequence: number;
  uuid: string;
  options: QuestionOptions[];
  dependencies: Dependancy[];
  createdAt: firebase.default.firestore.Timestamp;
  updatedAt: firebase.default.firestore.Timestamp;
  createdBy: string;
  createdByuserId: string;
}

export interface QuestionOptions {
  text: string;
  val: number;
}

export interface Options {
  options: string[];
}

export interface Survey {
  uuid: string;
  name: string;
  isActive: boolean;
  startdate: Date;
  createdBy: string;
  createdByuserId: string;
  studyRef: firebase.default.firestore.DocumentReference;
  studyName: string;
  studyId: string;
  createdAt: firebase.default.firestore.Timestamp;
  updatedAt: firebase.default.firestore.Timestamp;
  isDelete: boolean;
  groupIds?: Array<string>;
}

export interface Cognitive {
  uuid: string;
  cognitiveTestType: string; // 4type
  isActive: boolean;
  createdBy: string;
  createdByuserId: string;
  studyRef: firebase.default.firestore.DocumentReference;
  studyName: string;
  studyId: string;
  createdAt: firebase.default.firestore.Timestamp;
  updatedAt: firebase.default.firestore.Timestamp;
  isDelete: boolean;
  cognitiveTestName: string;
  cognitiveTestDescription: string;
  maxDurationOfTest: number;
  numberofGo: number;
  numberofNoGo: number;
  errorMsgDuration: number;
  testDurationPvt: number;
  eachTimerBetweenMinPvt: number;
  eachTimerBetweenMaxPvt: number;
  abortDurationPvt: number;
  totalTrialGambling: number;
  initalAmoutGambling: number;
  maxGameDurationGambling: number;
  noOfGainDecOne: number;
  noOfLossDecOne: number;
  noOfLossPercentageDecOne: number;
  noOfGainDecTwo: number;
  noOfLossDecTwo: number;
  noOfLossPercentageDecTwo: number;
  noOfGainDecThree: number;
  noOfLossDecThree: number;
  noOfLossPercentageDecThree: number;
  noOfGainDecFour: number;
  noOfLossDecFour: number;
  noOfLossPercentageDecFour: number;
  skills: [];
  durationDisplayWords: number;
  durationUserAnswer: number;
  passPercentage: number;
  totalNumberroundswordPair: number;
}

export interface Dependancy {
  answer1: [string];
  qUUID: string;
}

// export interface ConditionalQuestion {
// }
